<template>
    <div class="fs-form">

        <fsForm @submit="signup" name="Passwort vergessen" :formData="formData" />
    </div>
</template>

<script>
import fullscreenForm from "@/components/fullscreenForm"
import Parse from 'parse'
import {toast} from '@/utils/interactions'

export default {
    components: {
        fsForm: fullscreenForm
    },
    methods: {
        signup() {
            var form = this.formData,
                mail = form.email.value;
            if (mail) {
                Parse.User.requestPasswordReset(mail).then(() => {
                    toast('Eine E-Mail für die Passwortrücksetzung wurde versendet');
                    this.$router.push('/login');
                }).catch((err) => {
                    toast(
                        'Bei der Passwortrücksetzung ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Administrator.'
                    );
                    this.$router.push('/login');
                });
            } else {
                toast(
                    'Bitte geben Sie eine E-Mail-Adresse ein.'
                );
            }
        },
        goto_login() {
            this.$router.push('/login');
        },
        register() {
            this.$router.push('/announcements');
        },
    },
    mounted() {
        
    },
    data() {
        return {
            formData: {
                email: {
                    type: "email",
                    label: "E-Mail eingeben",
                    placeholder: "julia.beyer@example.com",
                    required: true,
                },
                /*
                phone: {
                    type: "text",
                    label: "Telefonnummer eingeben",
                    placeholder: "0381 214 247 32",
                    required: true
                },
                address: {
                    type: "address",
                    label: "Adresse eingeben",
                    placeholder: "Straße Hausnummer, PLZ Stadt",
                    required: true
                },
                description: {
                    type: "textarea",
                    label: "Beschreibe dich in ein paar Worten.",
                    placeholder: "",
                    required: true
                },
                password: {
                    type: "password",
                    label: "Lege ein sicheres Passwort fest",
                    descr: "Ein sicheres Passwort besitzt Groß- und Kleinbuchstaben, Sonderzeichen und ist mindestens 8 Zeichen lang.",
                    placeholder: "Uer%gho442ar",
                    required: true,
                    validation(value) {
                        return value.length > 5;
                    }
                }
                */
            }
        }
    },
}
</script>

<style lang="scss">
    .fs-form {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background-color: $primary-color;
    }

</style>



// WEBPACK FOOTER //
// src/pages/forgot-password.vue